import { Cloudinary } from "cloudinary-core";

export const cloudinary = new Cloudinary({ cloud_name: "brandhub" });
